export class HatirlaticiEntity {
    id!: number;
    baslik!: string;
    aciklama!: string;
    planlanan_tarih!: Date | string | null;
    planlanan_saat!: Date | string | null;
    user_id!: number;
}